import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SendGridDroppedUnsubscribeProcessingId = Brand<number, 'SendGridDroppedUnsubscribeProcessingId'>;
export const SendGridDroppedUnsubscribeProcessingId = createBranded<SendGridDroppedUnsubscribeProcessingId>();
